module.exports = __webpack_public_path__ + "static/img/user.7be3dca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/user.png
// module id = HdUg
// module chunks = 5